module.exports = {
  COOKIE_NOTICE_ACCEPTED_NAME: "cookie_notice_accepted",
  COOKIE_ANALYTICS_ENABLED_NAME: "gdpr-analytics-enabled",
  COOKIE_FUNCTIONAL_ENABLED_NAME: "gdpr-functional-enabled",
  PARENTAL_GUIDES_SLUG: "parentalguides",
  EU_REPORT_2022_TAG: "eu-report-2022-pdf",
  EU_REPORT_2023_TAG: "eu-report-2023-pdf",
  EU_REPORT_2024_TAG: "eu-report-2024-pdf",
}
